module.exports = __webpack_public_path__ + "static/media/server.c531918a.jpg";